/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown> }} Meta_Rank_OrdinalInputs */



/**
* | rankOrdinal | output |
* | --- | --- |
* | "one" | "{rank}st" |
* | "two" | "{rank}nd" |
* | "few" | "{rank}rd" |
* | * | "{rank}th" |
*
* @param {Meta_Rank_OrdinalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_rank_ordinal = /** @type {((inputs: Meta_Rank_OrdinalInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Rank_OrdinalInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.rank}.`)
	if (locale === "fr") {
		const rankOrdinal = registry.plural("fr", i?.rank, { type: "ordinal" }, true);
		if (rankOrdinal === "one") return /** @type {LocalizedString} */ (`${i?.rank}er`);
		return /** @type {LocalizedString} */ (`${i?.rank}e`)
	}
	if (locale === "zh-Hans") {
		const rankOrdinal = registry.plural("zh-Hans", i?.rank, { type: "ordinal" }, true);
		if (rankOrdinal === "one") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		if (rankOrdinal === "two") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		if (rankOrdinal === "few") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		return /** @type {LocalizedString} */ (`第${i?.rank}名`)
	}
	if (locale === "zh-Hant") {
		const rankOrdinal = registry.plural("zh-Hant", i?.rank, { type: "ordinal" }, true);
		if (rankOrdinal === "one") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		if (rankOrdinal === "two") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		if (rankOrdinal === "few") return /** @type {LocalizedString} */ (`第${i?.rank}名`);
		return /** @type {LocalizedString} */ (`第${i?.rank}名`)
	}
	if (locale === "ko") {
		const rankOrdinal = registry.plural("ko", i?.rank, { type: "ordinal" }, true);
		if (rankOrdinal === "one") return /** @type {LocalizedString} */ (`${i?.rank}위`);
		if (rankOrdinal === "two") return /** @type {LocalizedString} */ (`${i?.rank}위`);
		if (rankOrdinal === "few") return /** @type {LocalizedString} */ (`${i?.rank}위`);
		return /** @type {LocalizedString} */ (`${i?.rank}위`)
	}
	{
		const rankOrdinal = registry.plural("en", i?.rank, { type: "ordinal" }, true);
		if (rankOrdinal === "one") return /** @type {LocalizedString} */ (`${i?.rank}st`);
		if (rankOrdinal === "two") return /** @type {LocalizedString} */ (`${i?.rank}nd`);
		if (rankOrdinal === "few") return /** @type {LocalizedString} */ (`${i?.rank}rd`);
		return /** @type {LocalizedString} */ (`${i?.rank}th`)
	}
});